"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M22 9h-5.586l5.293-5.293-1.414-1.414L15 7.586V2h-2v9h9V9zM2 15h5.586l-5.293 5.293 1.414 1.414L9 16.414V22h2v-9H2v2z" }), "Collapse");
//# sourceMappingURL=Collapse.js.map